package com.ervasstudio.tracoemovimento.model

data class Foto(val url: String)